import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import Navigation from '../../../Layouts/Navigation/Navigation';
import { BASE_URL } from '../../../utils/constants';

function AdminInquilinos() {
    const navigate = useNavigate();
    const [towers, setTowers] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
        const fetchTowers = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/towers`);
                setTowers(response.data);
            } catch (error) {
                console.error('Error fetching towers:', error);
            }
        };

        fetchTowers();
    }, []);

    const handleCardClick = (id_torre) => {
        navigate(`/controlInquilinos/${id_torre}`);
    };

    return (
        <>
            <Navigation/>
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6 lg:p-8">
                <div className="max-w-7xl mx-auto">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-10">
                        <button
                            onClick={() => navigate('/dashboard')}
                            className="flex items-center gap-2 bg-white hover:bg-gray-100 text-gray-700 px-4 py-2 rounded-lg shadow-md transition-all"
                        >
                            <FontAwesomeIcon icon={faArrowLeft} className="h-5 w-5" />
                            Volver
                        </button>
                        <div className="flex items-center">
                            <FontAwesomeIcon icon={faBuilding} className="h-10 w-10 text-primary-600 mr-3" />
                            <h1 className="text-4xl font-bold text-gray-800">
                                Seleccionar Torre
                            </h1>
                        </div>
                        <div className="w-24"></div>
                    </div>

                    {/* Tower Cards Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {towers.map((tower) => (
                            <div
                                key={tower.id_torre}
                                onClick={() => handleCardClick(tower.id_torre)}
                                className="bg-gradient-to-br from-primary-600 to-primary-700 rounded-2xl shadow-lg cursor-pointer hover:shadow-2xl hover:scale-105 transition-all duration-200 overflow-hidden"
                            >
                                <div className="p-6 flex items-center justify-between">
                                    <div className="flex-1">
                                        <h2 className="text-2xl font-bold text-white mb-2">
                                            {tower.nombre}
                                        </h2>
                                        <p className="text-primary-100 text-sm">
                                            Administrar Inquilinos
                                        </p>
                                        <div className="mt-4 flex items-center text-white text-sm">
                                            <span>Click para ver →</span>
                                        </div>
                                    </div>
                                    <div className="ml-4">
                                        <FontAwesomeIcon icon={faBuilding} className="h-20 w-20 text-white opacity-30" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Empty State */}
                    {towers.length === 0 && (
                        <div className="text-center py-12 bg-white rounded-2xl shadow-md">
                            <FontAwesomeIcon icon={faBuilding} className="h-24 w-24 text-gray-300 mx-auto mb-4" />
                            <p className="text-xl text-gray-500">No hay torres registradas</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}

export default AdminInquilinos;

